var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('v-app',[(_vm.snackbarData.isOpen)?_c('AppSnackBar',{attrs:{"show-snack-bar":_vm.snackbarData.isOpen,"snack-bar-msg":_vm.snackbarData.message,"image-name":_vm.snackbarData.image,"snack-bar-type":_vm.snackbarData.type},on:{"close-snack-bar":_vm.closeSnackbarAlert}}):_vm._e(),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }